import { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";

import Configuration from "../Configuration/Configuration";
import AppConfig from "../Configuration/AppConfig";
import Settings from "../../Settings/Settings";
import InfoButton from "../../Comman/InfoButton";

import { canShowPermission } from "../Permissions/permissionObject";
import TicketPage from "../../Settings/TicketPage";
import CreateDashboardInfo from "../../Comman/DashboardInfo/CreateDashboardInfo";

export default function SettingsPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewConfiguration = canShowPermission(
    permissions,
    "configuration",
    "view"
  );

  const canViewAppConfig = canShowPermission(
    permissions,
    "appConfig",
    "view"
  );

  const canViewSettings = canShowPermission(
    permissions,
    "settingsMain",
    "view"
  );

   const canViewTicket= canShowPermission(
    permissions,
    "ticket",
    "view"
  );

  const canViewPageInfo = canShowPermission(
    permissions,
    "jewellerPermission",
    "view"
  );

  const tabs = useMemo(
    () =>
      [
        canViewConfiguration && {
          label: t("tabs.jewellerConfigurations"),
          component: <Configuration />,
        },
        canViewAppConfig && {
          label: t("tabs.appConfigurations"),
          component: <AppConfig />,
        },
        canViewSettings && {
          label: t("common.settings"),
          component: <Settings />,
        },
        canViewPageInfo && {
          label: t("settings.pageInfo"),
          component: <CreateDashboardInfo />,
        },
      ].filter(Boolean),
    [t, canViewConfiguration, canViewAppConfig, canViewSettings, canViewPageInfo]
  );

  useEffect(() => {
    if (tabIndex >= tabs.length) {
      setTabIndex(0);
    }
  }, [tabs.length, tabIndex]);

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Paper
          sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
          elevation={1}
        >
          <Tabs
            value={tabIndex}
            onChange={(e, newValue) => setTabIndex(newValue)}
            variant="fullWidth"
            sx={{
              mb: 2,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              padding: "4px",
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "16px",
                textTransform: "none",
                borderRadius: "6px",
                margin: "0 4px",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#7A3FFF",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderBottom: "3px solid #7A3FFF",
                },
                "&:hover": {
                  backgroundColor: "rgba(122, 63, 255, 0.08)",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>

          <Box sx={{ mt: 0 }}>
            {tabs[tabIndex]?.component}
          </Box>
        </Paper>
      </Box>
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="SETTING" />
  </Box>
      </Box>
    </Box>
  );
}
